import { render, staticRenderFns } from "./DigitRoll.vue?vue&type=template&id=121319d0&scoped=true"
import script from "./DigitRoll.vue?vue&type=script&lang=js"
export * from "./DigitRoll.vue?vue&type=script&lang=js"
import style0 from "./DigitRoll.vue?vue&type=style&index=0&id=121319d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121319d0",
  null
  
)

export default component.exports